module.exports = __webpack_public_path__ + "img/experience_years_level.e601c141.svg";